import {Component, Prop, Vue, Watch} from "vue-property-decorator";

import vpcData from '../../../service/vpc/vpcData';
import trustVpcData from '../../../service/trust_vpc/vpcData';
import whiteList from '../../../service/common/whiteList';
import BaseIndexView from '../index/index.vue'
import apiRequest from '../../../service/vpc/request';
import GlobalEvent from '../../../service/common/GlobalEvent'

import {Select, Option} from 'kpc/components/select'
import * as format from '../../../service/vpc/format';
import * as _ from "lodash";
import {debounce} from "helpful-decorators";
import Tooltip from 'kpc/components/tooltip';

import azChinaFunc from '../../../service/common/azChinaFunc';
import commonApiRequest from '../../../service/common/apiRequest';

@Component({
    components: {
        Select, Option, Tooltip
    },
    mixins: [BaseIndexView]
})
export default class BaseVpcIndexView extends Vue {

    searchPlaceholder = this.$trans(`请输入关键字@desc=n`)

    // 是否支持云企业网
    userCenPermission = false

    // 是否支持路由表
    userRouteTablePermission = false

    // 是否支持新的路由表
    userNewRouteTablePermission = false

    // 加载vpc状态
    vpcInfoLoading = true

    vpcList: any[] = []
    currentVpc: any = {}
    // 互信vpc的权限判断
    trustVpcQuota = {
        msg: '',
        value:true
    }

    currVpcSupportIpv6 = false

    allowGlobalSecGroup = false

    get isVpcList() {
        const me: any = this;
        let str = me.$route.path;
        return str.indexOf('vpc/index') !== -1
    }

    get isTrustVpc(){
        const me: any = this;
        let str = me.$route.path;
        return str.indexOf('trust-vpc') !== -1
    }

    tooltipsContent(item: any) {
        return item.vpcName || ''
    }

    get supportSgTag() {
        const me: any = this;
        return whiteList.check('sgTag', me.region);
    }

    @Watch('region')
    regionWatcher() {
        const me: any = this;
        if (!me.region) {
            return;
        }
        me.clickRegion({
            code: me.region
        })

        if (me.isTrustVpc) {
            me.checkTrustVpcPermission()
        }else{
            try {
                me.checkUserRouteTablePermission();
                me.checkHavipUserPermission()
                me.CheckCenUserPermission()
                me.checkGlobalSecGroupUserPermission();
            } catch (e) {
            }
            let p = this.getVpcList()
            if (p) {
                p.then(() => {
                    me.getList(true)
                })
            }
        }
    }

    showAz(az?: any) {
        if (!az) {
            return '-'
        }
        // return this.$trans(`az_${_.last(az)}`);
        return azChinaFunc(az);
    }

    // 校验路由表是否有权限需要显示
    checkUserRouteTablePermission() {
        let me: any = this;
        let newAllow:boolean
        apiRequest.CheckNewRouteTableRegion({
            Region: me.region
        }).done((data: any) => {
            newAllow = data.Allow
            // 如果展示新的路由表，旧的路由和路由表就都不展示
            if (data.Allow) {
                me.userRouteTablePermission = false //旧路由表权限为false
                me.userNewRouteTablePermission = true //旧路由表权限为false
                sessionStorage.setItem('oldRouteTableAllow', 'false') //本地存储旧路由表的权限
                sessionStorage.setItem('newRouteTableAllow','true') //本地存储新路由表的权限
                if (me.$parent.userRouteTablePermissionChange) {
                    me.$parent.userRouteTablePermissionChange(false, true);
                }
                me.$emit('userRouteTablePermissionChange',false, true);
                GlobalEvent.$emit('userRouteTablePermissionChange', false, true);
            } else {
                // 如果新的路由表不展示，还需要请求旧路由表的quota
                apiRequest.GetRouteTableUserPermission({
                    Region: me.region
                }).done((data: any) => {
                    me.userRouteTablePermission = data.Allow;
                    me.userNewRouteTablePermission = false;
                    sessionStorage.setItem('oldRouteTableAllow', data.Allow ? 'true' : 'false') //本地存储旧路由表的权限
                    sessionStorage.setItem('newRouteTableAllow',newAllow ? 'true' : 'false') //本地存储新路由表的权限
                    if (me.$parent.userRouteTablePermissionChange) {
                        me.$parent.userRouteTablePermissionChange(data.Allow, newAllow);
                    }
                    me.$emit('userRouteTablePermissionChange', data.Allow, newAllow);
                    GlobalEvent.$emit('userRouteTablePermissionChange', data.Allow , newAllow);
                });
            }
        })
    }

    // 校验云企业网是否有权限需要显示
    CheckCenUserPermission() {
        let me: any = this;
        apiRequest.GetCenUserPermission({
            Region: KSC_SECNET_CONSOLE.ENV === 'dev' ? 'cn-qingyangtest-1' : 'cn-beijing-6'
        }).done((data: any) => {
            me.userCenPermission = data.Allow;
            if (me.$parent.userCenPermissionChange) {
                me.$parent.userCenPermissionChange(me.userCenPermission);
            }
            me.$emit('userCenPermissionChange', me.userCenPermission);
            GlobalEvent.$emit('userCenPermissionChange', me.userCenPermission);
        });
    }

    checkHavipUserPermission() {
        let me: any = this;
        commonApiRequest.DescribeQuotaByName({
            Region: me.region,
            QuotaName: 'quota_vpc_havip'
        }).done((data: any) => {
            if (me.$parent.userHavipPermissionChange) {
                me.$parent.userHavipPermissionChange(data.Allow);
            }
            me.$emit('userHavipPermissionChange', data.Allow);
            GlobalEvent.$emit('userHavipPermissionChange', data.Allow);
        });
    }

    checkGlobalSecGroupUserPermission() {
        let me: any = this;
        commonApiRequest.DescribeQuotaByName({
            Region: me.region,
            QuotaName: 'quota_vpc_globalsecuritygroupon'
        }).done((data: any) => {
            me.allowGlobalSecGroup = data.Allow;
        });
    }

    showVpcInfo(vpcItem: any) {
        return format.showVpcInfo(vpcItem);
    }

    selectVpc(item: any) {
        localStorage.vpcId = item.VpcId
        let currentVpc: any = {
            vpcId: item.VpcId,
            vpcName: item.VpcName + '(' + item.CidrBlock + ')'
        }
        this.currentVpc = currentVpc;
    }

    // 判断有没有互信vpc的权限
    checkTrustVpcPermission() {
        const me = this
        if (me.region) {
            if (!whiteList.check('vpcTrust2', me.region)) {
                this.getVpcList()
                me.trustVpcQuota.msg = this.$trans('当前数据中心不支持此功能')
                me.trustVpcQuota.value = false
            } else {
                commonApiRequest.DescribeQuotaByName({
                    Region: me.region,
                    QuotaName: 'quota_vpc_trust'
                }).done((data: any) => {
                    if (!data.Allow) {
                        this.getVpcList()
                        me.trustVpcQuota.msg = this.$trans('当前用户没有此功能权限，请联系金山云开通')
                        me.trustVpcQuota.value = false
                    } else {
                        let p = this.getVpcList()
                        if (p) {
                            p.then(() => {
                                me.getList(true)
                            })
                        }
                        me.trustVpcQuota.msg = ''
                        me.trustVpcQuota.value = true
                    }
                    
                })
                
            }
        }
    }

    @debounce(50)
    async getVpcList() {
        const me: any = this;
        let req: any;
        if (me.isVpcList) {
            // 互信vpc的数据源不一致
            req = me.isTrustVpc ?  trustVpcData.getVpcs(me.region) : vpcData.getVpcs(me.region);
        } else {
            req = me.isTrustVpc ?  trustVpcData.getVpcsOther(me.region) : vpcData.getVpcsOther(me.region);
        }
        me.vpcInfoLoading = true;
        return new Promise(resolve => {
            req.then((data: any) => {
                me.vpcList = data.vpcList;
                me.currentVpc = data.currentVpc;
                me.vpcInfoLoading = false;
                resolve(data);
            })
        });
    }

    @Watch("currentVpc", {
        deep: true
    })
    CurrentVpcWatcher(val: any, oldVal: any) {
        let me: any = this;
        if (!val.vpcId) { return; }
        const currVpc = _.find(me.vpcList, ["VpcId", val.vpcId]);
        if (currVpc && currVpc.Ipv6CidrBlockAssociationSet && currVpc.Ipv6CidrBlockAssociationSet.length > 0) {
            me.ipVersion = 'ipv6';
            me.currVpcSupportIpv6 = true;
        } else {
            me.ipVersion = 'ipv4';
            me.currVpcSupportIpv6 = false;
        }
    }

    // async mountedHandler() {
    //     const me: any = this;
    //     await me.getRegionDetail();
    //     // console.log(444)
    //     await me.getVpcList();
    //     // await me.getList(true);
    // }

    // async mounted() {
    // //     console.log(123,'vpc')
    // //     const me: any = this;
    //     await this.getRegionDetail();
    // //     await me.getVpcList();
    // //     await me.getList(true);
    // }


};
